import { useState } from 'react';
import { Navbar, Container, Nav, NavDropdown, Button } from 'react-bootstrap';

export default function AppNavbar() {
    const [menuOpen, setMenuOpen] = useState(false);
    const [zonaOpen, setZonaOpen] = useState(false);

    return (
        <>
            <Navbar expand="lg" fixed="top" className="custom-navbar">
                <Container>

                    {/* LOGO */}
                    <Navbar.Brand href="https://aicowp.smallsolutions.es/">
                        <img
                            src="/images/Logo-rojo.png"
                            alt="Logo"
                        />
                    </Navbar.Brand>

                    <div className="d-flex align-items-center ms-auto d-lg-none">

                        {/* BOTÓN SIEMPRE VISIBLE */}
                        <Button
                            as="a"
                            href="https://aicowp.smallsolutions.es/unete-a-nosotros/"
                            className="btn-unete me-3"
                        >
                            Únete a nosotros
                        </Button>

                        {/* HAMBURGUESA SIEMPRE VISIBLE */}
                        <div
                            className="hamburger"
                            onClick={() => setMenuOpen(true)}
                            style={{ cursor: 'pointer' }}
                        >
                            ☰
                        </div>
                    </div>

                    {/* MENÚ DESKTOP */}
                    <Navbar.Collapse className="justify-content-end">
                        <Nav className="align-items-center d-none d-lg-flex">

                            <NavDropdown title="Zona Cliente" id="zona-cliente" className="d-lg-block">
                                <NavDropdown.Item href="https://aicowp.smallsolutions.es/contratar-seguro/">Contratar Seguro</NavDropdown.Item>
                                <NavDropdown.Item href="https://aicowp.smallsolutions.es/atencion-al-cliente/">Atención al Cliente</NavDropdown.Item>
                                <NavDropdown.Item href="https://aicomediacion.es/clientes/login">Eclientes</NavDropdown.Item>
                                <NavDropdown.Item href="/identificacion">Pagar Póliza Online</NavDropdown.Item>
                            </NavDropdown>

                            <Nav.Link href="https://aico.smallsolutions.es/" className="d-lg-block">
                                Acceso a Profesionales
                            </Nav.Link>

                            <Button
                                as="a"
                                href="https://aicowp.smallsolutions.es/unete-a-nosotros/"
                                className="btn-unete ms-3"
                            >
                                Únete a nosotros
                            </Button>

                            {/* 👇 hamburguesa opcional también en desktop */}
                            <div
                                className="hamburger ms-3 d-none d-lg-block"
                                onClick={() => setMenuOpen(true)}
                            >
                                ☰
                            </div>

                        </Nav>
                    </Navbar.Collapse>
                </Container>
            </Navbar>

            {/* MENÚ LATERAL */}
            <div className={`aico-sidebar ${menuOpen ? 'open' : ''}`}>
                <div className="aico-sidebar__header">
                    <img src="/images/logotipo-transparente.png" alt="Logo" className="aico-sidebar__logo" />
                    <span onClick={() => setMenuOpen(false)}>✕</span>
                </div>

                <div className="aico-sidebar__content">
                    <div className="aico-sidebar__dropdown d-lg-none">
                        <button
                            type="button"
                            className="aico-sidebar__dropdown-title"
                            onClick={() => setZonaOpen(!zonaOpen)}
                        >
                            Zona Cliente {zonaOpen ? '▴' : '▾'}
                        </button>

                        <div className={`aico-sidebar__dropdown-menu ${zonaOpen ? 'open' : ''}`}>
                            <a href="https://aicowp.smallsolutions.es/contratar-seguro/">Contratar Seguro</a>
                            <a href="https://aicowp.smallsolutions.es/atencion-al-cliente/">Atención al Cliente</a>
                            <a href="https://aicomediacion.es/clientes/login">Eclientes</a>
                            <a href="/identificacion">Pagar Póliza Online</a>
                        </div>
                    </div>
                    <a href="https://aico.smallsolutions.es/" className="d-lg-none">Acceso a Profesionales</a>
                    <a href="https://aicowp.smallsolutions.es/quienesomos/" onClick={() => setMenuOpen(false)}>Quiénes Somos</a>
                    <a href="https://aicowp.smallsolutions.es/blog/" onClick={() => setMenuOpen(false)}>Blog</a>
                    <a href="https://aicowp.smallsolutions.es/contacto/" onClick={() => setMenuOpen(false)}>Contacto</a>
                </div>
            </div>

            {menuOpen && (
                <div
                    className="aico-sidebar__overlay"
                    onClick={() => setMenuOpen(false)}
                />
            )}
        </>
    );
}